import { useMutation } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getBusinessByAbnOrAcn } from '../../requests/getBusinessByAbnOrAcn';

export const useBusinessByAbnOrAcn = () => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: async (value: string) =>
      getBusinessByAbnOrAcn(constructGet, value),
  });

  return { getBusinessByAbnOrAcn: mutateAsync, ...rest };
};
